export const hasData = (data: Record<string, any> | null | undefined): boolean => {
  if (!data || typeof data !== "object") return false;

  const ignoredKeys = [
    "is_default_content",
    "template_default_content_id",
    "is_dynamic",
    "createdAt",
    "updatedAt",
    "countryCode",
  ];

  const hasOtherProps = Object.keys(data).some((key) => !ignoredKeys.includes(key));

  return hasOtherProps;
};
